import { render, staticRenderFns } from "./quequan.vue?vue&type=template&id=d2c36078&scoped=true&"
import script from "./quequan.vue?vue&type=script&lang=js&"
export * from "./quequan.vue?vue&type=script&lang=js&"
import style0 from "./quequan.vue?vue&type=style&index=0&id=d2c36078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c36078",
  null
  
)

export default component.exports